import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% extra de descuento',
  [OfferKindEnum.PercentageOffByProducts]: '{{percentageAmount}}% extra de descuento',
  [OfferKindEnum.AmountOffByProducts]: '{{amount}} extra de descuento',
  [OfferKindEnum.Bogo]: '2 POR 1',
  [OfferKindEnum.BogoHalfPrice]: '¡Compra 1 y lleva otro al 50%!',
  [OfferKindEnum.FreeItemByProducts]: 'Artículo gratis',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Artículo gratis',
};

export default OfferBadge;
